import { Redirect as RouterRedirect } from 'inferno-router';
import pathToRegexp from 'path-to-regexp';

const Redirect = ({ to, params }) =>
  <RouterRedirect to={pathToRegexp.compile(to)(params)} />;

export default Redirect;
